import Service from '@ember/service';

export default class PageTitleService extends Service {
  titleDidUpdate(/* title */) {}
}
